"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var value_checker_1 = __importDefault(require("../../../../common/src/utils/validation/value_checker"));
var InviteMailTemplate = /** @class */ (function () {
    function InviteMailTemplate() {
    }
    InviteMailTemplate.getContents = function (documentId, officeName, inviteMailSentenceType, personalEkycSkipFlg) {
        // 本人確認が必要なプラン
        var needIdentification = ['standard', 'tablet', 'upgrade', 'entry', 'toUpgrade', 'oldStandard', 'medium', 'professional'];
        // 本人確認をスキップするか否かの判定
        var isSkipEkyc = false;
        // モーションAIか否かの判定
        var needdMotionAi = ['motionAi'];
        // メール文を格納する
        var mainMessage = "";
        // 本人確認が必要か否かにより、文言が変わる
        var step3Sentence = "";
        // 本人確認が必要か否か
        if (value_checker_1.default.isPresent(personalEkycSkipFlg)) {
            isSkipEkyc = true;
        }
        if (inviteMailSentenceType.some(function (val) { return val === 'tablet'; })) {
            // タブレット単体申込みが含まれている場合は必ず本人確認が必要
            step3Sentence = '3. ご本人様・法人様確認審査完了後、弊社よりメールにて、お申込内容確定のご連絡をさせていただきます。\n';
        }
        else if (inviteMailSentenceType.some(function (val) { return needIdentification.includes(val); }) && !isSkipEkyc) {
            // 本人確認が必要なプラン
            step3Sentence = '3. ご本人様・法人様確認審査完了後、弊社よりメールにて、お申込内容確定のご連絡をさせていただきます。\n';
        }
        else if (inviteMailSentenceType.some(function (val) { return needIdentification.includes(val); }) && isSkipEkyc) {
            // 本人確認が必要なプランだが、本人確認をスキップする場合
            step3Sentence = '3. 3営業日以内に弊社よりメールにて、お申込内容確定のご連絡をさせていただきます。\n';
        }
        else {
            // 主にBasicプランとモーションAIの場合
            step3Sentence = '3. 3営業日以内に弊社よりメールにて、お申込内容確定のご連絡をさせていただきます。\n';
        }
        mainMessage = 'この度は、弊社サービスの導入申込手続きのご依頼をいただき誠にありがとうございます。\n';
        mainMessage += '\n';
        mainMessage += '以下手順に沿ってご対応をお願いいたします。\n';
        mainMessage += '\n';
        mainMessage += '1. 以下URLより導入申込画面に進んでください。\n';
        mainMessage += '\n';
        mainMessage += officeName + "\u5C02\u7528URL: " + location.protocol + "//" + location.host + "/update/" + documentId + "\n";
        mainMessage += '\n';
        mainMessage += '2. 導入申込画面より必要事項をご入力いただき、申込処理を行なってください。\n';
        if (inviteMailSentenceType.some(function (val) { return needdMotionAi.includes(val); })) {
            // モーションAI選択時
            mainMessage += '\n';
            mainMessage += "" + step3Sentence;
            mainMessage += '※ 利用規約( https://rehab.cloud/terms/ )の 第12条第2項で言及しているモーションAI';
            mainMessage += '\n';
            mainMessage += 'の測定ガイドラインは以下URLよりご覧いただけます。内容をご確認の上、お申し込みください。';
            mainMessage += '\n';
            mainMessage += 'https://cdn.motionai.rehab.cloud/measurment_guideline.pdf';
            mainMessage += '\n';
        }
        else {
            // モーションAI以外
            mainMessage += '\n';
            mainMessage += "" + step3Sentence;
            mainMessage += '\n';
        }
        mainMessage += '※メールに記載された導入申込リンクの有効期限は7日間です。\n';
        mainMessage += '※上記URLにアクセスできない場合は、担当営業までご連絡ください。\n';
        mainMessage += '※このメールに心あたりが無い場合は、破棄してください。\n';
        mainMessage += '※こちらのメールアドレスは送信専用のため、返信いただいても対応できません。\n';
        mainMessage += '\n';
        mainMessage += 'ご不明点は、下記連絡先までお問い合わせください。\n';
        mainMessage += '\n';
        mainMessage += '***************************************************************\n';
        mainMessage += '株式会社Rehab for JAPAN\n';
        mainMessage += '営業時間：10:00~18:00 [土・日・祝日除く]\n';
        mainMessage += 'TEL:050-5497-5155\n';
        mainMessage += '***************************************************************';
        return mainMessage;
    };
    return InviteMailTemplate;
}());
exports.default = InviteMailTemplate;



//////////////////
// WEBPACK FOOTER
// ./src/utils/mail/template/invite.ts
// module id = s4rU
// module chunks = 1